import { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ICArrowRightLarge32: FC<PropsT> = ({ fill = '#FEFEFE' }) => {
  return (
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7793 8.81507L19.1975 16.1953L11.7793 23.5756C11.4069 23.9461 11.4069 24.5469 11.7793 24.9174C12.1518 25.2879 12.7557 25.2879 13.1281 24.9174L21.2207 16.8662C21.5931 16.4957 21.5931 15.8949 21.2207 15.5244L13.1281 7.47322C12.7557 7.10268 12.1518 7.10268 11.7793 7.47322C11.4069 7.84376 11.4069 8.44453 11.7793 8.81507Z"
        fill={fill}
      />
    </svg>
  );
}

export default ICArrowRightLarge32;
import { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ICArrowRightLarge32: FC<PropsT> = ({ fill = '#FEFEFE' }) => {
  return (
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7793 8.81507L19.1975 16.1953L11.7793 23.5756C11.4069 23.9461 11.4069 24.5469 11.7793 24.9174C12.1518 25.2879 12.7557 25.2879 13.1281 24.9174L21.2207 16.8662C21.5931 16.4957 21.5931 15.8949 21.2207 15.5244L13.1281 7.47322C12.7557 7.10268 12.1518 7.10268 11.7793 7.47322C11.4069 7.84376 11.4069 8.44453 11.7793 8.81507Z"
        fill={fill}
      />
    </svg>
  );
}

export default ICArrowRightLarge32;
